import Image1 from '../img/portfolio/1.png';
import Image2 from '../img/portfolio/2.png';
import Image3 from '../img/portfolio/3.png';

import Image4 from '../img/portfolio/4.png';

import { motion } from 'framer-motion';
import { transition1 } from '../transitions';

import { TypeAnimation } from 'react-type-animation';
import { CursorContext } from '../context/CursorContext';
import React, { useContext } from 'react';

const Portfolio = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, x: window.innerWidth }}
      transition={transition1}
      className="section hero"
    >
      <div className="container mx-auto h-full relative">
        <div className="flex flex-col lg:flex-row  items-center justify-center gap-x-24 text-center  lg:text-center pt-18 lg:pt-36 text-primary pb-4">
          <div
            className="pt-20 pb-1 lg:pt-0 lg:w-auto z-8 flex flex-col justify-center items-center px-10 text-center lg:items-start text-primary "
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
          >
            <h1 className="h1">Projects</h1>
            <p className="mb-4 max-w-lg text-lg lg:text-xl  text-justify">
              After completion of several Projects gained lot of knowledge,This
              projects allowed me to gain hands-on experience in both front-end
              and back-end development, improving my skills and understanding of
              full-stack web development.
            </p>
          </div>

          <div className="grid grid-cols-2 lg:gap-10 gap-3 ">
            <div className="max-w-[200px] lg:max-w-[320px] h-[170px] lg:h-[220px]  overflow-hidden">
              <TypeAnimation
                className="text-xl font-semibold text-transparent leading-6 bg-clip-text bg-gradient-to-r from-gray-500 to-black"
                sequence={['Weather Application', 3000]}
                speed={20}
                style={{ fontSize: '1.2em' }}
                repeat={Infinity}
              />
              <br />
              <br />
              <a
                href="https://kameshwaran-weather-app.netlify.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="object-cover rounded-3xl lg:h-[180px] hover:scale-110  transition-all duration-500"
                  src={Image1}
                  alt=""
                />
              </a>
            </div>
            <div className="max-w-[200px] lg:max-w-[320px] h-[170px] lg:h-[220px]  overflow-hidden">
              <TypeAnimation
                className="text-xl font-semibold text-transparent leading-6 bg-clip-text bg-gradient-to-r  from-gray-500 to-black"
                sequence={['Google Keep Clone', 3000]}
                speed={10}
                style={{ fontSize: '1.2em' }}
                repeat={Infinity}
              />
              <br />
              <br />
              <a
                href="https://kameshwaran-google-keep-clone.netlify.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="object-cover rounded-3xl lg:h-[180px]  hover:scale-110  transition-all duration-500"
                  src={Image2}
                  alt=""
                />
              </a>
            </div>
            <div className="max-w-[200px] lg:max-w-[320px] h-[180px] lg:h-[220px]  overflow-hidden">
              <TypeAnimation
                className="text-3xl font-semibold text-transparent leading-10 bg-clip-text bg-gradient-to-r  from-gray-500 to-black"
                sequence={['YouTube Clone', 100]}
                speed={10}
                style={{ fontSize: '1.2em' }}
                repeat={Infinity}
              />
              <br />
              <br />
              <a
                href="https://kameshwaran-youtube-clone.netlify.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="object-cover  rounded-3xl lg:h-[180px] hover:scale-110  transition-all duration-500"
                  src={Image3}
                  alt=""
                />
              </a>
            </div>
            <div className="max-w-[200px] lg:max-w-[320px] h-[180px] lg:h-[220px]  overflow-hidden">
              <TypeAnimation
                className="text-3xl font-semibold text-transparent leading-6 bg-clip-text bg-gradient-to-r from-gray-500 to-black"
                sequence={['Amazon Clone', 1000]}
                speed={1}
                style={{ fontSize: '1.2em' }}
                repeat={Infinity}
              />
              <br />
              <br />
              <a
                href="https://kameshwaran-amazon-clone.netlify.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="object-cover  rounded-3xl lg:h-[180px] hover:scale-110  transition-all duration-500"
                  src={Image4}
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Portfolio;
